import BasicTabs from '../components/prototype/BasicTabs'

export default function Drive() {
  return (
    <div className="container">   
      <div className="page">
        <section className="align_center">
          <h2 >      
            V-Drive – Next-Generation Propulsion
          </h2>
        </section>  

        <BasicTabs />
    </div>
  </div>  
  );
};
